<template>
    <b-container>
        <div class="lt-fill">
            <b-row v-if="qdata.image1">
                <b-col>
                    <img class="mw-100" :src="qdata.image1.data.src" alt="">
                </b-col>
            </b-row>
            <div class="question-example mt-4">
                <p class="text-start section-title mb-0"><strong>Examples</strong></p>
                <div class="example__block border p-2 rounded">
                    <table style="font-size: 1.3rem;" v-if="!qdata.example">
                        <tbody>
                            <tr>
                                <td>
                                    <div class="p-1 text-start">What is the name of Kim’s dog?</div>
                                </td>
                                <td>
                                    <div class="p-1">
                                        <b-form-input disabled value="Ben"></b-form-input>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="p-1 text-start">How old is Kim’s dog?</div>
                                </td>
                                <td>
                                    <div class="p-1">
                                        <b-form-input disabled value="1"></b-form-input>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style="font-size: 1.3rem;" v-if="qdata.example">
                        <tbody>
                            <tr v-for="(item, index) in qdata.example.data.items" :key="index">
                                <td>
                                    <div class="p-1 text-start">
                                        {{ item.question.data.value }}
                                    </div>
                                </td>
                                <td>
                                    <div class="p-1">
                                        <b-form-input disabled type="text" :value="item.answer.data.value"></b-form-input>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="question-content mt-4">
                <p class="text-start section-title mb-0"><strong>Questions</strong></p>
                <table style="font-size: 1.3rem;">
                    <tbody>
                        <tr v-for="(item, index) in qdata.fillText.data.items" :key="index">
                            <td>
                                <div class="p-1 text-start">
                                    {{ item.question.data.value }}
                                </div>
                            </td>
                            <td>
                                <div class="p-1">
                                    <b-form-input type="text" @keydown="inputKeyDown" v-model="answer[index]"></b-form-input>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-container>
</template>

<script>


import {
    // BRow,
    // BCol,
    BFormInput,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'lt_fill',
    components: {
        // BRow,
        // BCol,
        BFormInput,
        BContainer,
    },
    props: {
        qdata: Object
    },
    data() {
        return {
            answer: []
        }
    },
    created() {
        for (let index = 0; index < this.qdata.fillText.data.items.length; index++) {
            this.answer[index] = null
        }
    },
    watch: {
        answer : {
            handler(value) {
                this.$emit('input', {
                    answers: value,
                })
            },
            deep: true
        }
    },
    methods: {
        inputKeyDown(event) {
            console.log(event)
            // document.querySelector('input#inputfocus').focus()
            event.target.focus();
        },
    }
}
</script>

<style scoped>

@media (max-width: 768px) {
    tr {
        display: flex;
        flex-direction: column;
        width: 100% !important;
    }
}

</style>